import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedDepot: '',
};

const routePlannerAppSlice = createSlice({
  name: 'routePlannerApp',
  initialState,
  reducers: {
    setSelectedDepot(state, action) {
      state.selectedDepot = action.payload;
    },
  },
});

export const { setSelectedDepot } = routePlannerAppSlice.actions;

export default routePlannerAppSlice.reducer;
